import ResourcesListings from "../../../Components/Pricings/Resources/ResourcesListings";

export default function ResourcesListing() {
    return (
        <div data-testid='resources-listings-component'>
        <ResourcesListings /></div>
    )
}